'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { range } from 'underscore';
import { connect } from 'react-redux';
import PromotingMenuDropTarget from 'simple-menus-lib/components/dnd/components/PromotingMenuDropTarget';
import * as applicationSelectors from 'simple-menus-core/selectors/application';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state) {
    return {
      isDragging: applicationSelectors.getIsDragging(state)
    };
  };
}
const HOC = Component => {
  class WithPromotingMenuDropTargets extends PureComponent {
    renderDropTargets() {
      const {
        hasChildren,
        isLastChild,
        moveNodeAction,
        isParentDragging,
        id,
        hierarchy,
        depthToNextSibling,
        depth: isNested,
        isDragging,
        menuId,
        readOnly
      } = this.props;
      if (hasChildren || !isLastChild || !isNested || !isDragging) return null;
      return range(this.props.depthToNextSibling).map(depth => {
        const targetIndex = hierarchy.length - (depthToNextSibling - depth);
        return /*#__PURE__*/_jsx(PromotingMenuDropTarget, {
          depth: depth,
          moveNode: moveNodeAction,
          isParentDragging: isParentDragging,
          id: id,
          targetId: hierarchy[targetIndex],
          targetParentId: hierarchy[targetIndex - 1],
          menuId: menuId,
          readOnly: readOnly
        }, depth);
      });
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        dropTargets: this.renderDropTargets()
      }));
    }
  }
  WithPromotingMenuDropTargets.defaultProps = {
    depth: 0,
    depthToNextSibling: 0
  };
  WithPromotingMenuDropTargets.propTypes = {
    isOver: PropTypes.bool,
    depth: PropTypes.number.isRequired,
    isLastChild: PropTypes.bool,
    hasChildren: PropTypes.bool,
    depthToNextSibling: PropTypes.number,
    hasSibling: PropTypes.bool,
    moveNode: PropTypes.func.isRequired,
    isParentDragging: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    isDragging: PropTypes.bool,
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    moveNodeAction: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
  };
  return connect(makeMapStateToProps, null)(WithPromotingMenuDropTargets);
};
export default function withPromotingMenuDropTargets() {
  return HOC;
}